import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { SORT_TYPES } from '@savgroup-front-common/constants/shared/sort';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartRequestLine,
} from '@savgroup-front-common/types';

import { SparePartRequestLineRubric } from '../../domains/sparePartRequests/requestLineList';

const ENDPOINT = `${APIConfiguration.sparePart}search/requestline`;

export interface SparePartRequestLineFilter {
  name: string;
  facets: {
    included: boolean;
    name: string;
  }[];
}

export interface GetSparePartRequestLinesArgs {
  page: number;
  pageSize: number;
  isDescending?: boolean;
  sort?: SORT_TYPES;
  query: string;
  filters?: SparePartRequestLineFilter[];
}

interface GetSparePartRequestLinesPayload {
  hitCount: number;
  hits: SparePartRequestLine[];
  rubrics: SparePartRequestLineRubric[];
}

export const getSparePartRequestLinesRequest = ({
  page,
  pageSize,
  isDescending,
  sort = SORT_TYPES.REQUEST_LINE_LAST_MODIFICATION_TIME_UTC,
  query,
  filters,
}: GetSparePartRequestLinesArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: {
      page,
      pageSize,
      isDescending,
      sort,
      query,
      filters,
    },
  },
});

export default async function getSparePartRequestLines(
  payload: GetSparePartRequestLinesArgs,
): Promise<
  BackResponse<GetSparePartRequestLinesPayload> | BackResponseFailure
> {
  try {
    return await executeQuery<BackResponse<GetSparePartRequestLinesPayload>>(
      getSparePartRequestLinesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
